import type { ReactNode } from 'react'
import { cx } from '@/utils/cx'

/**
 * Schaltfläche in den Maßen der Vorlage.
 *
 * 13 Pixel Schrift, Radius 10, Polster 8/14, ein Haarstrich als Rand, beim
 * Zeigen um einen Pixel angehoben. **Kein Bauteil aus Untitled UI:** Deren
 * Schaltfläche bringt Ring und Schatten mit, und wo hier zwei nebeneinander
 * im Kopf einer Seite stehen, fällt der Unterschied auf — an derselben Stelle
 * war die Kopfleiste schon einmal zu hoch.
 *
 * Drei Formen, mehr nicht: leise (Vorgabe), `stark` für die eine Handlung, die
 * eine Seite anbietet, und `gefahr` für das, was sich nicht zurücknehmen lässt.
 */
export interface KnopfProps {
  children: ReactNode
  stark?: boolean
  gefahr?: boolean
  onClick?: () => void
  disabled?: boolean
  /** Für Schaltflächen in einem Formular. Vorgabe ist `button`. */
  type?: 'button' | 'submit'
  className?: string
}

export function Knopf({
  children,
  stark,
  gefahr,
  onClick,
  disabled,
  type = 'button',
  className,
}: KnopfProps) {
  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      onClick={onClick}
      disabled={disabled}
      className={cx(
        'cursor-pointer rounded-[10px] border px-3.5 py-2 text-[13px] transition-[transform,border-color,background-color] duration-150 hover:-translate-y-px',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0',
        stark
          ? 'border-akzent bg-akzent font-semibold text-white hover:border-akzent-tief hover:bg-akzent-tief'
          : gefahr
            ? 'border-secondary bg-primary font-medium text-error-primary hover:border-error-primary'
            : 'border-secondary bg-primary font-medium text-primary hover:border-rand-aktiv',
        className,
      )}
    >
      {children}
    </button>
  )
}
